import { Card, OrderCardStatus, Organisation, User } from '@generated-types';
import { capitalizeFirsts } from '@utils/string';

export const isOrderedToNets = ({ orderStatus }: Card) => orderStatus === OrderCardStatus.ORDERED;

export const getOwnerName = (customer: Organisation | User) => {
    if ('name' in customer) {
        return customer.name;
    }
    if ('firstName' in customer && 'lastName' in customer) {
        return `${capitalizeFirsts(customer.firstName as string)} ${capitalizeFirsts(customer.lastName as string)}`;
    }
    return '';
};
